module.exports = __webpack_public_path__ + "assets/img/6299da98502f68cb50520bee2c211504.svg";